import { defineComponent, reactive,ref} from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import vueinstallapp from './../Shared/vueinstallapp.vue';
import { langdrivers, DriversAutoRequest, ServiceDriversApiViewModel, categories, MesDriversDriver2, MaterielXMLRelation, MesDriversMatos2 } from './driversstruct';
import * as bootstrap from "bootstrap";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import customProtocolCheck from "custom-protocol-check";
import { QuillEditor } from '@vueup/vue-quill';
import { boolean } from 'yup';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);
import * as duration from 'dayjs/plugin/duration';
dayjs.extend(duration);
import * as relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);
import CompteareboursComponent from '../../Views/Shared/comptearebours.vue';
import { InstallAppApiViewModel } from '../../Views/startdetection/index';
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import { VueSignalR, useSignalR } from './../../Scripts/js/signalrmonitoring.service';
import { createSignalRHubConnexion } from "./../Shared/DCSignalRConnection";
import { ProgressApp, TaskEnd } from './../../Scripts/js/SignalReceiver';
import { DriversInstallActionData } from './../Shared/AppCloudModel';
import { createPinia } from 'pinia';

let glangcurrent: string = "en";
let gidconfig: number = 0;
let glangdrivers: langdrivers[] = [];
let gnotifnewdrivermsg: string = "";
let gnotifnewsubmitbug: string = "";
let g_dcWebSocketServiceUrl: string = '';
export  enum NotifDriver { NONE = 0, UP = 1, DOWN = 2 };
export class DriversQuery {
    public lang: string = "";
    public  idconfig: number = 0;
    public menuosquery: number = 0;
    public notifdriver: NotifDriver | null = null;
    public updateoptions: boolean = true;
    public  mesdriversonlyrecent: boolean = true;
    public  mesdriversprintallmatos: boolean = false;
    public  mesdriversonlyWHQL: boolean = false;
    public  mesdriversbeta: boolean = false;
    public  mesdriversoem: boolean = false;
    public  mesdriverswinname: boolean = false;
    public mesdriversinstallauto: boolean = false;
    public savedriverauto: boolean = true;
    public filtragemateriel: boolean = true;
    public installcontrollerstorage: boolean = false;
}

export enum FilterDriversType { ALL = 1,One=2, Min = 3,OneDriver=4 };

export class FilterDriverElement {
    public  iddriver: number = 0;
    public type: FilterDriversType = FilterDriversType.ALL;
    public hidbase: string = "";
    public date: Date | null = null;
    public version: string = "";
}

export class AddFilterRequest {
    public  idconfiguser: number = 0;
    public filters: FilterDriverElement[] = [];
    }

export class view_filterdrivers {
    public idnum: number = 0;
    public userid: number = 0;
    public md5hostname: string = "";
    public hidbase: string = "";
    public datemin: Date | null = null;
    public versionmin: string = "";
    public type: FilterDriversType = FilterDriversType.ALL;
}

export class FilterDriversApiViewModel {
    public m_filterdrivers: view_filterdrivers[] = [];
}

export enum ignoretype { DESAC = 0, ALL = 1, ONE = 2 };

export class BugDriverRequest {
    public userid: number = 0;
    public idconfig: number = 0;
    public hardwareid: string = "";
    public namematos: string = "";
    public iddriver: number = 0;
    public namedriver: string = "";
    public description: string = "";
}

export class listecheckeditem {
    public key: string = "";
    public value: string = "";
    public matosname: string = "";
}

export class listechecked {
    public key: categories = categories.Others;
    public categorie: string = "";
    public listedrivers: listecheckeditem[]=[]
}


const mixin = defineComponent({
    components: { QuillEditor, CompteareboursComponent, vueinstallapp },
    data() {
        return {
            signalrhub : useSignalR(),
            loadingdetect: false,
            initloading: false,
            langcurrent:"en",
            idconfig: 0,
            dcWebSocketServiceUrl: '' as string,
            dateconfigexpiration: null as Date | null,
            bugdescription:"" as string,
            viewmodel: null as ServiceDriversApiViewModel | null,
            viewignorelist: null as FilterDriversApiViewModel | null,
            ignorehidbase: "",
            ignoredriver: null as MesDriversDriver2|null,
            m_modalsettings: null as bootstrap.Modal | null,
            m_modalignore: null as bootstrap.Modal | null,
            m_modalsignalbug: null as bootstrap.Modal | null,
            langdrivers: null as any,
            checkeddrivers: null as Map<string,string>|null,
            notifnewdrivermsg: "",
            modeignore: ignoretype.DESAC as ignoretype,
            categoryignore:-1,
            ignoredriverlist: [] as string[],
            filterrequest: null as AddFilterRequest | null,
            notifnewsubmitbug: "",
            signalerbugidmatos: "",
            signalermatos: null as MesDriversMatos2 | null,
            signalerbugdriver: "",
            viewappli: null as InstallAppApiViewModel | null,
            dc_descpilotesreferer: "",
            showdownload: false,
            listechecked: [] as listechecked[],
            progressautopilotepourcentage: 0 as number,
            progressautopilotedesc: "" as string,
            m_hostname: "" as string
        }
    },
    methods: {
        DetectionModalLoad(url: string) {
            let self = this;
            axios.get<InstallAppApiViewModel>(url).then(function (response: AxiosResponse<InstallAppApiViewModel>) {
                if (response.data !== null) {
                    self.viewappli = response.data;
                }
            });


        },
        DCInstallModelApplication(url: string) {

            this.DetectionModalLoad(url);
            let elt = document.getElementById('dc_installappdialog');
            if (elt !== null) {
                let modal = new bootstrap.Modal(elt, {});
                modal.show();
            }
        },
        SaveRestoreDriver(url:string,referer:string) {
            this.dc_descpilotesreferer = referer;
            this.loadingdetect = true;
            customProtocolCheck(
                url,
                () => {
                    this.DCInstallModelApplication("/api/v1.0/startdetection/InstallApp?lancurrent=" + this.langcurrent);
                    this.loadingdetect = false;
                },
                () => {
                    this.loadingdetect = false;
                }
            );
            return false;
        },
        SignalerLoadDrivers(matosjson: string) {
         this.signalermatos=   JSON.parse(matosjson) as MesDriversMatos2;
        },
        OpenLoginModalAndCloseSettings(event: any) {
            if (this.m_modalsettings!=null)
            this.m_modalsettings.hide();
        },
        IgnoreAll(category:number,matos: MesDriversMatos2) {
            this.modeignore = ignoretype.ALL;
            this.categoryignore = category;
            this.filterrequest = new AddFilterRequest();
            this.filterrequest.idconfiguser = this.idconfig;
            this.filterrequest.filters = [];
            this.ignoredriverlist = [];
            if (matos === null||matos.drivers==null)
                return;
            for (let driver of matos.drivers) {
                this.ignoredriverlist.push(matos.materiel_hid + '--' + driver.driver_code);
                matos.materiel_driversanterieur = true;
            }
        },
        IgnoreOne(category: number, matos: MesDriversMatos2) {
            this.modeignore = ignoretype.ONE;
            this.categoryignore = category;
            this.filterrequest = new AddFilterRequest();
            this.filterrequest.idconfiguser = this.idconfig;
            this.filterrequest.filters = [];
            if (this.viewmodel === null)
                return;
            this.ignoredriverlist = [];
            for (let category of this.viewmodel.materielxmlrelations) {
                for (let matos of category.value) {
                    if (matos.drivers != null) {
                        for (let driver of matos.drivers) {
                            if (driver.driver_ignoredriver) {
                                this.ignoredriverlist.push(matos.materiel_hid + '--' + driver.driver_code);

                            }
                        }
                    }
                }
            }
            matos.materiel_driversanterieur = true;
        },
        GetIgnoreList() {
            let url: string = "/api/v1.0/filterdrivers/GetDrivers?idconfiguser=" + this.idconfig;
            let self = this;
            axios.get<FilterDriversApiViewModel>(url).then(function (response: AxiosResponse<FilterDriversApiViewModel>) {
                if (response !== null)
                    if (response.data) {
                        self.viewignorelist = response.data;
                    }
            });
        },
        AddFilter(request: AddFilterRequest, matos: MesDriversMatos2[]) {
            let url: string = "/api/v1.0/filterdrivers/AddFilter";
            let self = this;
            axios.post<boolean>(url, request).then(function (response: AxiosResponse<boolean>) {
                if (response !== null)
                    if (response.data) {
                        if (self.m_modalignore!==null)
                            self.m_modalignore.hide();
                        if (self.viewmodel !== null) {
                            const query: DriversQuery = new DriversQuery();
                            query.idconfig = self.idconfig;
                            query.updateoptions = false;
                            query.notifdriver = NotifDriver.NONE;
                            query.menuosquery = self.viewmodel.osactual;
                            self.ListDrivers(query, matos,false);
                        }
                    }
            });
        },
        SetModeIgnore(event:any) {
           // alert("SetModeIgnore");
            event.stopPropagation();
            this.modeignore = ignoretype.ONE;
            this.filterrequest = new AddFilterRequest();
            this.filterrequest.idconfiguser = this.idconfig;
            this.filterrequest.filters = [];
            if (this.viewmodel === null)
                return;
            for (const [catindex, categorie]  of this.viewmodel.materielxmlrelations.entries()) {
                for (const [indexmatos, matos] of categorie.value.entries()) {
                    if (this.checkeddrivers!=null&&this.checkeddrivers.get(catindex + '_' + indexmatos)!=undefined)
                    this.checkeddrivers.delete(catindex + '_' + indexmatos);
                    if (matos.drivers != null) {
                        for (let driver of matos.drivers) {
                            if (driver.driver_ignoredriver) {
                                this.ignoredriverlist.push(matos.materiel_hid + '--' + driver.driver_code);

                            }
                        }
                    }
                }
            }
        },
        ValiderIgnore(catindex:number,matos: MesDriversMatos2[]) {
            if (this.modeignore !== ignoretype.DESAC) {
                //alert("ClearModeIgnore");
                this.modeignore = ignoretype.DESAC;
                this.categoryignore = -1;
                for (const [indexmatos, matosone] of matos.entries()) {

                    if (this.checkeddrivers!=null&&this.checkeddrivers.get(catindex + '_' + indexmatos) != undefined) {
                        this.checkeddrivers.delete(catindex + '_' + indexmatos);
                    }
                }
                for (let value of this.ignoredriverlist) {
                    const values = value.split("--");
                    this.AddOneDriverFilter(values[0], +values[1]);
                }
                
                if (this.filterrequest!==null)
                this.AddFilter(this.filterrequest,matos);
            }
        },
        IsIgnore(matos: MesDriversMatos2, driver: MesDriversDriver2): boolean {
            if (this.modeignore != ignoretype.DESAC)
                return (this.ignoredriverlist.indexOf(matos.materiel_hid + "--" + driver.driver_code) >= 0);
            else
                return driver.driver_ignoredriver;
        },
    AnnulerIgnore() {

        if (this.modeignore !== ignoretype.DESAC) {
            //alert("ClearModeIgnore");
            this.modeignore = ignoretype.DESAC;
            this.categoryignore = -1;
        }
    },
        AddFullFilter(hidbase:string) {
            const request: FilterDriverElement = new FilterDriverElement();
            request.hidbase = hidbase;
            request.type = FilterDriversType.ALL;
            if (this.filterrequest!==null)
                this.filterrequest.filters.push(request);
        },
        AddMinFilter(hidbase: string, driver: MesDriversDriver2) {
            const request: FilterDriverElement = new FilterDriverElement();
            request.hidbase = hidbase;
            if (driver !== null) {
                request.date = driver.inf_date;
                request.version = driver.inf_version;
                request.type = FilterDriversType.Min;
                if (this.filterrequest !== null)
                    this.filterrequest.filters.push(request);
            }
        },
        AddOneFilter(hidbase: string, driver: MesDriversDriver2) {
            const request: FilterDriverElement = new FilterDriverElement();
            request.hidbase = hidbase;
            if (driver !== null) {
                request.date = driver.inf_date;
                request.version = driver.inf_version;
                request.type = FilterDriversType.One;
                if (this.filterrequest !== null)
                    this.filterrequest.filters.push(request);
            }
        },
        AddOneDriverFilter(hidbase: string,drivercode:number) {
            const request: FilterDriverElement = new FilterDriverElement();
            request.hidbase = hidbase;
                request.iddriver = drivercode;
                request.type = FilterDriversType.OneDriver;
                if (this.filterrequest !== null)
                    this.filterrequest.filters.push(request);
        },
        NotifDriver(notif: boolean, notifdriversmsgactive: string, notifdriversmsgdesactive: string) {
            
            const query: DriversQuery = new DriversQuery();
            if (this.viewmodel !== null) {
                query.idconfig = this.idconfig;
                query.updateoptions = false;
                if (notif) {
                    query.notifdriver = NotifDriver.UP;
                    this.LaunchNotif(notifdriversmsgactive);
                }
                else {
                    query.notifdriver = NotifDriver.DOWN;
                    this.LaunchNotif(notifdriversmsgdesactive);
                }
                query.menuosquery = this.viewmodel.osactual;
                this.ListDrivers(query,null,false);
            }
        },
        LaunchNotif(msg: string) {
            Swal.fire({
                   toast: true,
                position: 'top-end',
                icon: 'success',
                customClass: {
                    container: 'dctoastcontainer'
                },
                title: msg,
                showConfirmButton: false,
                timer: 2500
            })
        },
        changeCheck(index: string, checked: boolean, value: string) {
            if (this.checkeddrivers == null)
                return;
            if (checked) {
                this.checkeddrivers.set(index, value);
            }
            else {
                this.checkeddrivers.delete(index);
            }
            this.FillCheckedList();
            this.$forceUpdate();
        },
        IsCheck(index: string, value: string): boolean {
            if (this.checkeddrivers == null)
                return false;
            let resvalue = this.checkeddrivers.get(index);
            let retbool: boolean = false;
            if (resvalue != undefined)
                retbool = (resvalue === value);
            return retbool;
        },
        IsCheckDown(): boolean {
            return true;
        },
        FermerDownloads() {
            this.showdownload = !this.showdownload;
        },
        GetDescDriver(valuepilote: string) {
            if (this.viewmodel == null)
                return "unknown";
            let parts: string[] = valuepilote.split("_");
            if (parts.length < 2)
                return "unknown";
            let infcode: number = +parts[0];
            for (let category of this.viewmodel.materielxmlrelations) {
                for (let matos of category.value) {
                    if (matos.drivers != null) {
                        for (let driver of matos.drivers) {
                            if (driver.inf_code == infcode)
                                return driver.driver_nom;
                        }
                    }
                }
            }
            return "unknown";
        },
        StartDriverAuto(urlhandler: string, referer:string) {
            const request: DriversAutoRequest = new DriversAutoRequest();
            request.idconfig = this.idconfig;
            request.checkeddrivers = [];
            this.loadingdetect = true;
            if (this.checkeddrivers !== null) {
                for (let [index,value] of this.checkeddrivers) {
                    {
                        let parts = value.split('_');
                        if (parts.length>=2)
                            request.checkeddrivers.push(+parts[0]);
                    }
                }
            }
            this.dc_descpilotesreferer = referer;
            const url = "/api/v1.0/servicedrivers/FillDriverAuto";
            let self = this;
            axios.post<boolean>(url, request).then(function (response: AxiosResponse<boolean>) {
                if (response !== null) {
                    if (response.data) {
                        customProtocolCheck(
                            urlhandler,
                            () => {
                                self.DCInstallModelApplication("/api/v1.0/startdetection/InstallApp?lancurrent=" + self.langcurrent);
                                self.loadingdetect = false;
                            },
                            () => {
                                self.loadingdetect = false;
                            }
                        );
                    }
                    else
                        self.loadingdetect = false;
                }
                else
                    self.loadingdetect = false;
            });
        },
        OpenInfoDrivers(id: string) {
            let elt = document.getElementById(id);
            if (elt !== null) {
                let modal = new bootstrap.Modal(elt, {});
                modal.show();
            }
        },
        OpenInfoDriversSettings(id: string) {
            let elt = document.getElementById(id);
            if (elt !== null) {
                this.m_modalsettings = new bootstrap.Modal(elt, {});
                this.m_modalsettings.show();
            }
        },
        GetCategoryMaterielDesc(categorie: categories):string {
            let name:string = "";
            switch (categorie) {
                case categories.Others:
                    name = "mesdriverscatothers";
                    break;
                case categories.Ecran:
                    name = "confmenuscreen";
                    break;
                case categories.Firewire:
                    name = "confmenufirewire";
                    break;
                case categories.HardDrive:
                    name = "confmenudisquesdurs";
                    break;
                case categories.Imprimante:
                    name = "mesdriverscatprinter";
                    break;
                case categories.Keyboard:
                    name = "confmenukeyboard";
                    break;
                case categories.Motherboard:
                    name = "confmenucartemere";
                    break;
                case categories.Mouse:
                    name = "confmenumouse";
                    break;
                case categories.Optical:
                    name = "confmenulecteurscddvd";
                    break;
                case categories.PCIDisplay:
                    name = "confmenugraphics";
                    break;
                case categories.PCIMultimedia:
                    name = "mesdriverscatpcimultimedia";
                    break;
                case categories.PCINetwork:
                    name = "mesdriverscatpcinetwork";
                    break;
                case categories.PCIothers:
                    name = "confmenupciagp";
                    break;
                case categories.PCIStockage:
                    name = "mesdriverscatpcistockage";
                    break;
                case categories.PNP:
                    name = "confmenupnp";
                    break;
                case categories.Processor:
                    name = "confmenuprocesseur";
                    break;
                case categories.USB:
                    name = "confmenuusb";
                    break;
                case categories.USBClass:
                    name = "confmenuusb";
                    break;
                case categories.USBMultimedia:
                    name = "mesdriverscatusbmultimedia";
                    break;
                case categories.PCIUSB:
                    name = "confmenupciusb";
                    break;
                case categories.PCIFirewire:
                    name = "confmenupcifirewire";
                    break;
                default:
                    name = "mesdriverscatothers";
                    break;
            }
            return this.langdrivers.get(name);
        },
        isTouchDevice() {
            return 'ontouchstart' in window || (window as any)['DocumentTouch'] && document instanceof (window as any)['DocumentTouch'];
        },
        ReloadTooltips() {
            $("[data-bs-toggle='tooltip']").tooltip('hide');
            this.$nextTick(function () {
                if (!this.isTouchDevice()) {
                    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                        return new bootstrap.Tooltip(tooltipTriggerEl)
                    });
                }
                else
                    $('[data-bs-toggle="tooltip"]').removeAttr("title");
            });
        },
        FillCheckedList() {
            if (this.viewmodel == null)
                return;
            this.listechecked = [];
            const listedrivers: Map<number, boolean> = new Map<number, boolean>();
            for (const [catindex, categorie] of this.viewmodel.materielxmlrelations.entries()) {
                let item: listechecked = new listechecked();
                item.key = categorie.key;
                item.categorie = this.GetCategoryMaterielDesc(categorie.key);
                item.listedrivers = [];
                for (const [indexmatos, matos] of categorie.value.entries()) {

                    if (matos.drivers != null && matos.drivers.length > 0) {
                        for (const driver of matos.drivers) {
                            if (this.checkeddrivers!=null&&this.checkeddrivers.get(catindex + '_' + indexmatos) == (driver.inf_code + '_' + matos.materiel_id)) {
                                let valueitem: listecheckeditem = new listecheckeditem();
                                
                                valueitem.value = driver.inf_code + '_' + matos.materiel_id;
                                valueitem.key = catindex + '_' + indexmatos;
                                valueitem.matosname = matos.materiel_providername+ " " + matos.materiel_devicename;
                                if (!listedrivers.get(driver.inf_code)) {
                                    item.listedrivers.push(valueitem);
                                    listedrivers.set(driver.inf_code, true);
                                }
                            }
                        }
                    }
                }
                if (item.listedrivers.length > 0)
                    this.listechecked.push(item);
            }
        },
        ListDrivers(query: DriversQuery, matosold: MesDriversMatos2[]|null,init:boolean) {
            let url: string = "/api/v1.0/servicedrivers/ListDrivers";
            let self = this;
            query.lang = this.langcurrent;
            axios.post<ServiceDriversApiViewModel>(url, query).then(function (response: AxiosResponse<ServiceDriversApiViewModel>) {
                if (response !== null)
                    if (response.data) {
                        self.viewmodel = response.data;
                        if (self.viewmodel.m_dateconfigexpiration === null)
                            self.dateconfigexpiration = null;
                        else
                            self.dateconfigexpiration = dayjs(self.viewmodel.m_dateconfigexpiration).local().toDate();
                        self.ReloadTooltips();

                        for (const [catindex, categorie] of self.viewmodel.materielxmlrelations.entries()) {
                            for (const [indexmatos, matos] of categorie.value.entries()) {
                                if (matosold != null && matosold.map(m => m.materiel_id).indexOf(matos.materiel_id) >= 0) {

                                    matos.materiel_driversanterieur = true;
                                }
                                if (init && self.checkeddrivers != null && matos.drivers != null && matos.drivers.length > 0 && !self.IsIgnore(matos, matos.drivers[0]))
                                    self.checkeddrivers.set(catindex + '_' + indexmatos, matos.drivers[0].inf_code + '_' + matos.materiel_id);
                            }
                        }
                        self.FillCheckedList();
                        // console.error(JSON.stringify(self.viewmodel));
                    }
                self.initloading = true;
            });


        },
        RemoveFirstDriver(drivers: MesDriversDriver2[]): MesDriversDriver2[] {
            return drivers.slice(1);

        },
        PlierCategorie(cat: MaterielXMLRelation) {
            cat.active = !cat.active;
            this.ReloadTooltips();
        },
        PlierAll() {
            if (this.viewmodel === null)
                return;
            const isactive = this.viewmodel.materielxmlrelations[0].active;
            for (const cat of this.viewmodel.materielxmlrelations) {
                cat.active = !isactive;
            }
            this.ReloadTooltips();
        },

        PlierDriversanterieur(matos: MesDriversMatos2) {
            matos.materiel_driversanterieur = !matos.materiel_driversanterieur;
            this.ReloadTooltips();
        },
        ChangeOS(idconfig: number, osquery: number) {
             const query: DriversQuery = new DriversQuery();
             query.idconfig = idconfig;
            query.updateoptions = false;
            query.notifdriver = NotifDriver.NONE;
             query.menuosquery = osquery;
             this.ListDrivers(query,null,true);
        },
        ChangeOptions() {
            const query: DriversQuery = new DriversQuery();
            query.idconfig = this.idconfig;
            query.updateoptions = true;
            query.notifdriver = NotifDriver.NONE;
            if (this.viewmodel !== null && this.viewmodel.mcdroptions !== null && this.viewmodel.mcdroptions.length >= 9 && this.viewmodel.mcdroptions2 !== null && this.viewmodel.mcdroptions2.length>=1) {
                query.menuosquery = this.viewmodel.osactual;
                query.mesdriversonlyrecent = this.viewmodel.mcdroptions[0].ischecked;
                query.mesdriversprintallmatos = this.viewmodel.mcdroptions[1].ischecked;
                query.mesdriversonlyWHQL = this.viewmodel.mcdroptions[2].ischecked;
                query.mesdriversbeta = this.viewmodel.mcdroptions[3].ischecked;
                query.mesdriversoem = this.viewmodel.mcdroptions[4].ischecked;
                query.mesdriverswinname = this.viewmodel.mcdroptions[5].ischecked;
                query.mesdriversinstallauto = this.viewmodel.mcdroptions[6].ischecked;
                query.filtragemateriel = this.viewmodel.mcdroptions[7].ischecked;
                query.savedriverauto = this.viewmodel.mcdroptions2[0].ischecked;
                query.installcontrollerstorage = this.viewmodel.mcdroptions[8].ischecked;
                this.ListDrivers(query, null, true);
                if (this.m_modalsettings!==null)
                this.m_modalsettings.hide();
            }
        },
        SendBugDriver(request: BugDriverRequest) {
            let url: string = "/api/v1.0/bugdriver/AddBug";
            let self = this;
            axios.post<number>(url, request).then(function (response: AxiosResponse<number>) {
                if (response !== null) {
                    if (self.m_modalsignalbug!=null)
                    self.m_modalsignalbug.hide();
                    if (response.data >= 0) {
                        self.LaunchNotif(self.notifnewsubmitbug);
                    }
                }
            });
        },
        SendBugDriverDemande() {
            let request: BugDriverRequest = new BugDriverRequest();
            request.idconfig = this.idconfig;
            if (this.viewmodel != null)
                request.userid = this.viewmodel.m_iduser;
            else
                request.userid = 0;
            request.description = this.bugdescription;
            const driver: MesDriversDriver2 = JSON.parse(this.signalerbugdriver) as MesDriversDriver2;
            request.iddriver = driver.driver_code;
            const matos = JSON.parse(this.signalerbugidmatos) as MesDriversMatos2;
            request.hardwareid = matos.materiel_hid;
            request.namematos = matos.materiel_providername + " " + matos.materiel_devicename;
            request.namedriver = driver.driver_nom;
            this.SendBugDriver(request);
        },
        DCSignalerBugModal() {
            const elt = document.getElementById('dc_signalerbugdialog');
            if (elt !== null) {
                this.m_modalsignalbug = new bootstrap.Modal(elt, {});
                this.m_modalsignalbug.show();
            }
        },
         SendProgressApp(data: ProgressApp) {
             console.log("data:" + data.pourcentage + " " + data.text);
             this.progressautopilotepourcentage = data.pourcentage;
             this.progressautopilotedesc = data.text;
        },
       async InstallDriversAux(hostname:string, idconfig: number) {
            const request: DriversInstallActionData = new DriversInstallActionData();
            request.hostname = [hostname];
            request.idconfig = idconfig;
            await axios.post<boolean>(`${this.dcWebSocketServiceUrl}/api/v1.0/WebSocket/InstallDrivers`, request);

        },

        async JoinGroupByUser()
        {
            console.log("JoinGroupByUser");
            if (this.signalrhub != null) {
                await this.signalrhub.invoke("JoinGroupUser");
            }
        },


        async InstallDrivers(hostname: string) {
            this.m_hostname = hostname;
            const url = "/api/v1.0/servicedrivers/FillDriverAuto";
            const request: DriversAutoRequest = new DriversAutoRequest();
            request.idconfig = this.idconfig;
            request.checkeddrivers = [];
            this.loadingdetect = true;
            if (this.checkeddrivers !== null) {
                for (let [index, value] of this.checkeddrivers) {
                    {
                        let parts = value.split('_');
                        if (parts.length >= 2)
                            request.checkeddrivers.push(+parts[0]);
                    }
                }
            } 
            await axios.post<boolean>(url, request); 
            await this.InstallDriversAux(hostname, this.idconfig);
        }
    },

   async mounted() {
       this.langcurrent = glangcurrent;
       this.dcWebSocketServiceUrl = g_dcWebSocketServiceUrl;
        this.checkeddrivers = new Map<string, string>();
        this.idconfig = gidconfig;
        this.notifnewdrivermsg = gnotifnewdrivermsg;
        this.langdrivers = new Map(glangdrivers.map(key => [key.key, key.value] as [string, string]));
        const query: DriversQuery = new DriversQuery();
        query.idconfig = this.idconfig;
        query.updateoptions = false;
        query.menuosquery = 0;
        query.notifdriver = NotifDriver.NONE;
        this.notifnewsubmitbug = gnotifnewsubmitbug;
        this.ListDrivers(query, null, true);
        await this.signalrhub.init();
        await this.JoinGroupByUser();
       const self = this;
       this.signalrhub.onReconnected(async () => {
           console.log("signalrhub.onreconnected");
           await self.JoinGroupByUser();
       });
        this.signalrhub.on("SendProgressApp", (data: ProgressApp) => {
            if (this.m_hostname != "" && data.hostname == this.m_hostname)
                this.SendProgressApp(data);
        });
        this.signalrhub.on("TaskEnd", (data: TaskEnd) => {
            this.loadingdetect = false;
        }); 
    }
});


export class ServiceDriversComponent {
    public Init(baseurl: string, dcWebSocketServiceUrl: string, lang:string,idconfig: number, langdrivers: langdrivers[], notifnewdrivermsg: string, notifnewsubmitbug:string) {
        glangcurrent = lang;
        g_dcWebSocketServiceUrl = dcWebSocketServiceUrl;
        gidconfig = idconfig;
        glangdrivers = langdrivers;
        gnotifnewdrivermsg = notifnewdrivermsg;
        gnotifnewsubmitbug = notifnewsubmitbug;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.use(PerfectScrollbar);
        const connection = createSignalRHubConnexion(`${dcWebSocketServiceUrl}/SignalRDriversCloud`);
        app.use(VueSignalR, connection);
        app.mount('#rootpage');
    }
}

(<any>(window)).ServiceDriversComponent = function () { return new ServiceDriversComponent(); };